import { render } from "./AllUserInsurances.vue?vue&type=template&id=73be8d1b&scoped=true"
import script from "./AllUserInsurances.vue?vue&type=script&lang=js"
export * from "./AllUserInsurances.vue?vue&type=script&lang=js"

import "./AllUserInsurances.vue?vue&type=style&index=0&id=73be8d1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73be8d1b"]])

export default __exports__